import * as React from 'react';
import { useSelector } from 'react-redux';

import { ADD_TO_COMPARE_BANNER_TEXT, COMPARISON_ENTRYPOINTS_ENABLED_CONFIG } from './constants';
import { ComparisonBanner } from '../../components/ComparisonBanner';
import { getComparisonStatus } from '../../selectors/newbuilding';
import { useApplicationContext } from '../../utils/applicationContext';
import { NewbuildingCompareButton } from '../NewbuildingCompareButton';
import { COMPARE_ENABLED_CONFIG } from '../NewbuildingCompareButton/constants';

export const ComparisonContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const comparisonStatus = useSelector(getComparisonStatus);
  const isComparisonEntrypointsEnabled = config.get<boolean>(COMPARISON_ENTRYPOINTS_ENABLED_CONFIG) || false;
  const isCompareEnabled = config.get<boolean>(COMPARE_ENABLED_CONFIG) || false;
  const isComparisonAvailable = comparisonStatus === 'added' || comparisonStatus === 'available';

  if (!isComparisonEntrypointsEnabled || !isCompareEnabled || !isComparisonAvailable) {
    return null;
  }

  return (
    <ComparisonBanner
      compareButton={
        <NewbuildingCompareButton
          buttonTheme="inverted"
          addToCompareText={ADD_TO_COMPARE_BANNER_TEXT}
          source="ask_author"
        />
      }
    />
  );
};
